/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationStoreBank131DisableRecurrentPaymentResponse } from './FxIdApplicationStoreBank131DisableRecurrentPaymentResponse';
import {
    FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSON,
    FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSONTyped,
    FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSON,
    FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSONTyped,
} from './FxIdApplicationStoreBank131DisableRecurrentPaymentResponse';
import type { FxGamesLibWebRpcContractsResponseResponseError } from './FxGamesLibWebRpcContractsResponseResponseError';
import {
    FxGamesLibWebRpcContractsResponseResponseErrorFromJSON,
    FxGamesLibWebRpcContractsResponseResponseErrorFromJSONTyped,
    FxGamesLibWebRpcContractsResponseResponseErrorToJSON,
    FxGamesLibWebRpcContractsResponseResponseErrorToJSONTyped,
} from './FxGamesLibWebRpcContractsResponseResponseError';

/**
 * 
 * @export
 * @interface FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse
 */
export interface FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse
     */
    Success: boolean;
    /**
     * 
     * @type {FxIdApplicationStoreBank131DisableRecurrentPaymentResponse}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse
     */
    Data: FxIdApplicationStoreBank131DisableRecurrentPaymentResponse;
    /**
     * 
     * @type {FxGamesLibWebRpcContractsResponseResponseError}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse
     */
    Error?: FxGamesLibWebRpcContractsResponseResponseError | null;
}

/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse(value: object): value is FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('Data' in value) || value['Data'] === undefined) return false;
    return true;
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseFromJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse {
    return FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'Data': FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsResponseResponseErrorFromJSON(json['Error']),
    };
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseToJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse {
    return FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponseToJSONTyped(value?: FxGamesLibWebRpcContractsFxGamesResponseOfDisableRecurrentPaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'Data': FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsResponseResponseErrorToJSON(value['Error']),
    };
}

